import "./mosaic_v2_core.js"
var req = require.context('../../../public/javascripts/backbone/apps/mosaic_v2_mobile/', true, /\.js$/)
req.keys().forEach(req)